var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.75 5c0-.9665.7835-1.75 1.75-1.75h11.5c.2702 0 .5195.14534.6526.38048.1332.23513.1295.52369-.0095.75539l-1.2558 2.09302.7367 1.10508c.1194.179.1561.40061.1009.60853s-.1971.38211-.3895.47832l-3.5165 1.75828.4236 2.9648c.053.3711-.1761.7243-.5365.8272l-2.78745.7965 1.30502 4.7851c.06151.2255.01435.4668-.12754.6525-.14189.1858-.36228.2948-.59603.2948h-5.5c-.96649 0-1.75-.7835-1.75-1.75zm1.75-.25c-.13807 0-.25.11193-.25.25v14c0 .1381.11192.25.25.25h4.51806l-1.24163-4.5527c-.10806-.3962.12264-.8056.51753-.9184l2.87104-.8204-.40746-2.8524c-.04566-.31961.11831-.63255.40706-.77692l3.2401-1.62005-.5287-.7931c-.1608-.24116-.1682-.55337-.0191-.8019l.8185-1.36413z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.3759 3.58397c.1391-.20864.3733-.33397.624-.33397h1.5c.9666 0 1.75.78351 1.75 1.75v14c0 .9665-.7834 1.75-1.75 1.75h-8.5c-.3348 0-.6291-.222-.7211-.544l-1-3.5c-.1138-.3982.1168-.8133.5151-.9271l2.8821-.8235-.4203-3.3624c-.041-.328.1376-.6441.4396-.7784l3.7254-1.65566-1.0639-1.77307c-.1491-.24853-.1417-.56074.0191-.8019zm1.0254 1.16603-1.514 2.27111 1.2558 2.09302c.1105.18422.1367.407.072.61186s-.2142.37211-.4105.45941l-3.9914 1.7739.431 3.4477c.0458.3669-.1826.7125-.5382.8141l-2.7789.794.6386 2.2349h7.9342c.1381 0 .25-.1119.25-.25v-14c0-.13808-.1119-.25-.25-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.75 8.25c0-.82841.67159-1.5 1.5-1.5s1.5.67159 1.5 1.5-.67159 1.5-1.5 1.5-1.5-.67159-1.5-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBreak);
export default __webpack_public_path__ + "static/media/image_break.f427fba0d90a70e16084ad893bdbfd78.svg";
export { ForwardRef as ReactComponent };